// Small helpers around the auth data persisted in localStorage.
// The admin dashboard is restricted to users with the ADMIN role.

export const ADMIN_ROLE = 'ADMIN'

export const getToken = () => localStorage.getItem('token')

export const getStoredUser = () => {
  try {
    const raw = localStorage.getItem('user')
    return raw ? JSON.parse(raw) : null
  } catch {
    return null
  }
}

export const isAdmin = () => {
  const user = getStoredUser()
  return !!getToken() && user?.role === ADMIN_ROLE
}

// Persist the relevant pieces of a successful login response.
export const setSession = (loginResponse) => {
  if (loginResponse?.access_token) {
    localStorage.setItem('token', loginResponse.access_token)
  }
  if (loginResponse?.refresh_token) {
    localStorage.setItem('refresh_token', loginResponse.refresh_token)
  }
  if (loginResponse?.user) {
    localStorage.setItem('user', JSON.stringify(loginResponse.user))
  }
}

// Merge updated fields into the persisted user (e.g. after editing the profile).
export const updateStoredUser = (patch) => {
  const current = getStoredUser() || {}
  const next = { ...current, ...patch }
  localStorage.setItem('user', JSON.stringify(next))
  return next
}

export const clearSession = () => {
  localStorage.removeItem('token')
  localStorage.removeItem('refresh_token')
  localStorage.removeItem('user')
}
